(function () {
    if (document.querySelectorAll(".js-footer").length > 0) {

        const footer = {
            init: () => {
                footer.scrollToTop();
            },
            scrollToTop: () => {
                const button = document.getElementById("footer-to-top");

                if (button !== null) {
                    button.addEventListener("click", () => {
                        window.scrollTo({
                            top: 0,
                            left: 0,
                            behavior: 'smooth'
                        })
                    })
                }
            }
        }

        footer.init();
    }
})();